<template lang="pug">
    fragment
        div.statisticsHeader
            // Title
            title-component(
                :title="titleByRole"
                type="h2"
            )
        v-layout(row wrap justify-space-between align-center)
            v-flex(xs12 lg5 v-if="(isAdmin || isChampion) && !id")
                div

                    // Businesses select
                    select-component.mr-5(
                        v-if="isAdmin"
                        :label="$t('statistics.select.business')"
                        :items="businesses"
                        :callbackFunction="filterCallback"
                        name="businessId"
                    )

                    // Departments select
                    select-component.mr-3(
                        v-if="departments && departments.length"
                        :label="$t('statistics.select.department')"
                        :items="departments"
                        :callbackFunction="filterCallback"
                        name="department"
                    )

                    // Departments select for business
                    select-component.mr-3(
                        v-if="isChampion && depts && depts.length"
                        :label="$t('statistics.select.department')"
                        :items="depts"
                        :callbackFunction="filterCallback"
                        name="department"
                    )

                    template(v-if="isChampion && customFields" v-for="field in customFields")
                        // Departments select for business
                        select-component.mr-3(
                            :label="getFieldName(field.id)"
                            :items="field.items"
                            :callbackFunction="filterCustomCallback"
                            :name="field.id"
                            flat
                        )

            v-flex(xs12 lg7 :class="{betweenFilters: (isMember || id)}")
                div.dateFilters
                    div

                        // Periods
                        periods(
                            :id="id"
                            :callbackFunction="rangeCallback"
                        )

                    div.hidden-sm-and-up(v-if="isAdmin || isChampion")
                        div.usersCounter {{ `# Members ${counter}` }}
                        div Participants who logged their mood before and after a meditation session

                    separator-component.hidden-sm-and-up

            v-flex(
                xs12
                v-if="period === 'range'"
                :class="{betweenFilters: (isMember || id)}"
            )
                div.text-sm-right

                    // Date range
                    range-component(
                        :id="id"
                        :rangeCallback="rangeCallback"
                    )

        separator-component

        widgets(:id="id")

        separator-component

        div.mt-4(v-if="isChampion || isAdmin")
            // Title
            title-component(
              v-if="!id"
              title="Unique users"
              type="h5"
            )

            line-chart-amplitude.chart(v-if="!id")

            separator-component(v-if="!id")

            // Title
            title-component.mt-4(
              title="Overall logged mood by Users"
              type="h5"
            )
</template>

<script>
    import Layout from '../Layout/Layout';
    import ManagerPeriods from './Periods/ManagerPeriods';
    import Widgets from './Widgets';
    import Range from '~components/Range';
    import Select from '~components/Select';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import VueTypes from 'vue-types';
    import customFields from '~api/customFields';
    import LineChartAmplitude from './Chart/LineChartAmplitude';
    import numberWithCommas from '~filters/numberWithCommas';

    export default {
        filters: {
            numberWithCommas
        },
        components: {
            Layout,
            LineChartAmplitude,
            Periods: ManagerPeriods,
            Widgets,
            TitleComponent: Title,
            SelectComponent: Select,
            SeparatorComponent: Separator,
            RangeComponent: Range
        },
        props: {
            id: VueTypes.string.def('')
        },
        data() {
            return {
                depts: [],
                customFields: []
            };
        },
        computed: {
            ...mapFields('statistics', ['filter']),
            ...mapGetters('document', ['fieldsFormatted']),
            ...mapGetters('statistics', [
                'counter',
                'views',
                'userName',
                'period'
            ]),
            ...mapGetters('businesses', ['businesses']),
            ...mapGetters('auth', [
                'user',
                'isAdmin',
                'isChampion',
                'isMember'
            ]),
            titleByRole() {
                if (this.isMember) {
                    return 'My Practice';
                }
                if (this.id && this.userName) {
                    return `Statistics - ${this.userName}`;
                } else {
                    return 'Statistics';
                }
                //return this.isMember ? 'My Practice' : 'Statistics';
            },
            departments() {
                let departmentsList;

                this.businesses.map(item => {
                    if (this.filter.businessId === item.value) {
                        departmentsList = item.departments;
                    }
                });

                return departmentsList;
            }
        },
        async created() {
            this.updateRange(this.id);

            if (this.isAdmin) {
                this.getterBusinessesWithDepartments();
            }

            // If champion
            if (this.isChampion) {
                this.readFields(this.user.id);
                let departments = [];
                let { business } =
                    JSON.parse(window.localStorage.getItem('user')) || [];

                if (business?.userDepartments?.length) {
                    business.userDepartments.map(item => {
                        departments.push({
                            title: item,
                            value: item
                        });
                    });
                }

                this.depts = departments || [];

                const customFieldsResp = await customFields.getCustomFields();

                // TODO: Ask about unique fields
                if (customFieldsResp.ok)
                    customFieldsResp.data.result = [
                        customFieldsResp.data.result[0]
                    ];
                this.customFields = customFieldsResp.data.result.map(item => {
                    return {
                        id: Object.keys(item)[0],
                        items: Object.values(item)[0]
                    };
                });
            }
        },
        methods: {
            ...mapActions('statistics', ['setRange', 'updateRange']),
            ...mapActions('businesses', ['getterBusinessesWithDepartments']),
            ...mapActions('document', ['readFields']),

            /**
             * Update range on changes in filters
             */
            filterCallback(e) {
                this.filter[e.name] = e.value;
                if (e.name === 'businessId') {
                    this.filter.department = null;
                }

                this.updateRange(this.id);
            },
            /**
             * Custom fields filter
             */
            filterCustomCallback(e) {
                this.filter.department = null;
                this.filter.customFields = JSON.stringify([
                    { id: e.name, value: e.value }
                ]);

                this.updateRange();
            },

            getFieldName(id) {
                return this.fieldsFormatted[id];
            },

            /**
             * Set new range when dates changes in date pickers
             * @param {object} e
             * @returns {*}
             */
            rangeCallback(e) {
                if (this.id) return this.setRange({ ...e, id: this.id });
                return this.setRange(e);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl"

    .chart
      height: 400px

    .betweenFilters
        flex-basis: 100% !important
        max-width: 100% !important

        & > div
            justify-content: space-between;

    .dateFilters
        display: flex
        justify-content: flex-end
        align-items: center

    .usersCounter
        display: inline-block

    .chartWrapper
        padding: 16px
        border-radius: 10px
        background: rgba(255, 255, 255, 0.1)
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)

    .statisticsHeader
        display: flex
        align-items: center
        justify-content: space-between

    .usersCounterChampion
        font-size: 16px
        margin-bottom: 10px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .dateFilters
            margin-top: 10px
            flex-direction: column-reverse
            justify-content: flex-start
            align-items: flex-start

        .usersCounter
            font-size: 16px
            font-weight: 700
            margin-bottom: 10px
            margin-top: 0

        .statisticsHeader
            flex-direction: column
            justify-content: flex-start
            align-items: flex-start
</style>
